import { render, staticRenderFns } from "./FormMealPlanSatisfaction.vue?vue&type=template&id=70fd5db9"
import script from "./FormMealPlanSatisfaction.vue?vue&type=script&lang=js"
export * from "./FormMealPlanSatisfaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports